module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/bg_mv2512-sp-96a750edbc163b1d4e75de325ed04aa2.jpg";